import {
  Dumbbell, Zap, Activity, Trophy, Users, ShieldCheck, Wind, Heart, Flame, Target,
  Sparkles, Mountain, Hourglass,
} from "lucide-react";

// Day types with premium color palette
export const DAY_TYPES = {
  partido: { label: "Partido", color: "#E11D2E", bg: "rgba(225,29,46,0.12)", border: "rgba(225,29,46,0.5)", icon: Trophy },
  partido_suplente: { label: "Partido suplente", color: "#F97316", bg: "rgba(249,115,22,0.10)", border: "rgba(249,115,22,0.45)", icon: ShieldCheck },
  equipo: { label: "Entreno equipo", color: "#F5C518", bg: "rgba(245,197,24,0.10)", border: "rgba(245,197,24,0.45)", icon: Users },
  fuerza: { label: "Fuerza", color: "#3B82F6", bg: "rgba(59,130,246,0.10)", border: "rgba(59,130,246,0.45)", icon: Dumbbell },
  explosividad: { label: "Explosividad", color: "#A855F7", bg: "rgba(168,85,247,0.10)", border: "rgba(168,85,247,0.45)", icon: Sparkles },
  velocidad: { label: "Velocidad", color: "#A855F7", bg: "rgba(168,85,247,0.10)", border: "rgba(168,85,247,0.45)", icon: Zap },
  movilidad: { label: "Movilidad", color: "#22D3EE", bg: "rgba(34,211,238,0.10)", border: "rgba(34,211,238,0.45)", icon: Wind },
  recuperacion: { label: "Recuperación", color: "#22C55E", bg: "rgba(34,197,94,0.10)", border: "rgba(34,197,94,0.45)", icon: Heart },
  descanso: { label: "Descanso", color: "#737373", bg: "rgba(115,115,115,0.10)", border: "rgba(115,115,115,0.4)", icon: Hourglass },
  activacion: { label: "Activación / Prepartido", color: "#F97316", bg: "rgba(249,115,22,0.10)", border: "rgba(249,115,22,0.45)", icon: Flame },
  tests: { label: "Tests", color: "#EAB308", bg: "rgba(234,179,8,0.10)", border: "rgba(234,179,8,0.45)", icon: Target },
};

export const DAY_TYPE_LIST = Object.entries(DAY_TYPES).map(([k, v]) => ({ value: k, ...v }));

// Block types with icons
export const BLOCK_TYPES = {
  activacion: { label: "Activación", icon: Flame, color: "#F97316" },
  movilidad: { label: "Movilidad", icon: Wind, color: "#22D3EE" },
  isometria: { label: "Isometría", icon: ShieldCheck, color: "#A855F7" },
  pliometria: { label: "Pliometría", icon: Mountain, color: "#A855F7" },
  velocidad: { label: "Velocidad", icon: Zap, color: "#A855F7" },
  explosividad: { label: "Explosividad", icon: Sparkles, color: "#EAB308" },
  sprints: { label: "Sprints", icon: Target, color: "#EAB308" },
  fuerza: { label: "Fuerza", icon: Dumbbell, color: "#3B82F6" },
  accesorios: { label: "Accesorios", icon: Activity, color: "#3B82F6" },
  core: { label: "Core", icon: Target, color: "#3B82F6" },
  recuperacion: { label: "Recuperación", icon: Heart, color: "#22C55E" },
};

export const BLOCK_TYPE_LIST = Object.entries(BLOCK_TYPES).map(([k, v]) => ({ value: k, ...v }));

export const SPANISH_MONTHS = [
  "Enero","Febrero","Marzo","Abril","Mayo","Junio",
  "Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre",
];
export const SPANISH_DOW = ["L","M","X","J","V","S","D"];

export function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
}

export function monthLabel(d) {
  return `${SPANISH_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function monthKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function buildMonthMatrix(year, month) {
  // Returns array of 42 dates (6 weeks) starting Monday
  const first = new Date(year, month, 1);
  // Monday=0..Sunday=6
  const offset = (first.getDay() + 6) % 7;
  const start = new Date(year, month, 1 - offset);
  const out = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    out.push(d);
  }
  return out;
}
